import {
  Configuration,
  ConfigurationParameters,
  UserProjectRelation,
} from "@/api";
import { defineStore } from "pinia";
import KeycloakService from "../services/keycloak-service";
import { UserApi } from "../api/api";

export const useAuthStore = defineStore({
  id: "storeAuth",
  state: () => {
    const isDevMode =
      import.meta.env.DEV &&
      JSON.parse(import.meta.env.VITE_KEYCLOAK_DEACTIVATED);

    return {
      authenticated: isDevMode ? true : false,
      user: isDevMode
        ? ({
            username: "user1",
            email: "test@email.de",
            firstName: "User",
            // Change this role in development to test different authorizations
            userRole: UserProjectRelation.UserRoleEnum.LicenceManager, // <-- Change this to test different roles
          } as UserProjectRelation)
        : {},
      keycloakObj: undefined as any,
    };
  },
  // persist: true,
  getters: {
    /**
     * returning keycloak-obj if exists, otherwise create new one
     * @returns
     */

    getKeycloakObj(state): any {
      if (!state.keycloakObj) {
        state.keycloakObj = KeycloakService.getKeycloakObj();
      }
      return state.keycloakObj;
    },
    getAuthenticated(state): boolean {
      return state.authenticated;
    },

    isLicenceManager(state): boolean {
      return (
        state.user.userRole === UserProjectRelation.UserRoleEnum.LicenceManager
      );
    },

    isSimpleUser(state): boolean {
      return (
        state.user.userRole === UserProjectRelation.UserRoleEnum.SimpleUser
      );
    },

    isTestUser(state): boolean {
      return state.user.userRole === UserProjectRelation.UserRoleEnum.TestUser;
    },

    /**
     * Check if user has required role
     * @param state
     * @param requiredRole
     * @returns
     */
    hasRole:
      (state) =>
      (requiredRole: string): boolean => {
        const role = state.user.userRole as any;
        return requiredRole === role;
      },
    // Helper getter to get current user role
    currentUserRole(state): UserProjectRelation.UserRoleEnum | null {
      return state.user.userRole || null;
    },
  },

  actions: {
    // Initialize Keycloak OAuth
    storeLogin(keycloakObj: any, clearData = true) {
      this.keycloakObj = keycloakObj;
      if (clearData) {
        this.clearUserData();
      }

      this.authenticated = keycloakObj.authenticated;
      this.user.username = keycloakObj.idTokenParsed.preferred_username;
      this.user.token = keycloakObj.token;
      this.user.refToken = keycloakObj.refreshToken;
    },
    /**
     * retrieve additional user-data like user-role, user-scopes (general user-data are retrieved in storeLogin())
     * @param keycloakObj
     * @param clearData
     */
    async retrieveUserData() {
      await KeycloakService.updateAccessToken();
      const accessTokenFunc = (name: string, scopes: string[]) =>
        KeycloakService.getAccessToken();

      const configParam: ConfigurationParameters = {
        accessToken: accessTokenFunc,
      };
      const config = new Configuration(configParam);
      try {
        const res = await new UserApi(config, undefined, fetch).getUserData();
        // for now just assign user-role, later other additional user-data will be relevant
        this.user.userRole = res.userrole;

        // scopes may be relevant later
        // this.user.userScopes =
      } catch (err) {
        console.log("retrieveUserData-error=", err);
      }
    },
    // Clear user's store data
    clearUserData() {
      this.authenticated = false;
      this.user = {};
    },
    // Optional helper action to get current user token
    getCurrentToken(): string | null {
      if (
        import.meta.env.DEV &&
        JSON.parse(import.meta.env.VITE_KEYCLOAK_DEACTIVATED)
      ) {
        return "dev-mock-token";
      }
      return this.keycloakObj?.token || null;
    },
  },
});
